import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import MiracorePoints from "../pages/miracore-points/page";
import LoveFestival202526 from "../pages/lovefestival202526/page";
import Anniversary30 from "../pages/30anniversary/page";
import HappyBag2026Page from "../pages/happybag2026/page";
import Enkaku2026Page from "../pages/2026enkaku/page";
import Yochisachi2026Page from "../pages/yochisachi2026/page";
import RainbowDragon2026001Page from "../pages/rainbowdragon2026001/page";
import NeoEarthCultureFesPage from "../pages/neoearthculturefes/page";
import SecretSeminar202601Page from "../pages/secretseminar202601/page";
import ThankYouMiraPage from "../pages/secretseminar202601/thankyoumira/page";
import SpcAcademy2026Page from "../pages/spcacademy2026/page";
import SpcAcademyEntry202601Page from "../pages/spcacademy/entry202601/page";
import CurriculumPage from "../pages/spcacademy/entry202601/curriculum/page";
import CoreMemberPage from "../pages/coremember/page";
import ActWorkook202601Page from "../pages/actworkook202601/page";
import Thanks2026lms3dayPage from "../pages/Thanks/2026lms3day/page";
import Thanks2026lmsspghPage from "../pages/Thanks/2026lmsspgh/page";
import Thanks2026lms3dayhPage from "../pages/Thanks/2026lms3dayh/page";
import Thanks2026lms3daymPage from "../pages/Thanks/2026lms3daym/page";
import Thanks2026lms3daymp1Page from "../pages/Thanks/2026lms3daymp1/page";
import Thanks2026lms3dayme1Page from "../pages/Thanks/2026lms3dayme1/page";
import Thanks2026lms3dayh1Page from "../pages/Thanks/2026lms3dayh1/page";
import Thanks2026lms3dayhetoptsPage from "../pages/Thanks/2026lms3dayhetopts/page";
import Thanks2026lms3dayhetoptsHPage from "../pages/Thanks/2026lms3dayhetoptsH/page";
import Thanks2026lmssoudanPage from "../pages/Thanks/2026lmssoudan/page";
import Thanks2026lmssoudan319Page from "../pages/Thanks/2026lmssoudan319/page";
import Thanks2026lmssoudan322Page from "../pages/Thanks/2026lmssoudan322/page";
import Thanks2026lmssoudan324Page from "../pages/Thanks/2026lmssoudan324/page";
import Thanks2026lmssoudan327Page from "../pages/Thanks/2026lmssoudan327/page";
import KeikoanaguchisecretLIVE20260323Page from "../pages/keikoanaguchisecretLIVE20260323/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/miracle1",
    element: <MiracorePoints />,
  },
  {
    path: "/lovefestival202526",
    element: <LoveFestival202526 />,
  },
  {
    path: "/30Anniversary",
    element: <Anniversary30 />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/happybag2026",
    element: <HappyBag2026Page />,
  },
  {
    path: "/2026enkaku",
    element: <Enkaku2026Page />,
  },
  {
    path: "/yochisachi2026",
    element: <Yochisachi2026Page />,
  },
  {
    path: "/rainbowdragon2026001",
    element: <RainbowDragon2026001Page />,
  },
  {
    path: "/neoearthculturefes",
    element: <NeoEarthCultureFesPage />,
  },
  {
    path: "/secretseminar202601",
    element: <SecretSeminar202601Page />,
  },
  {
    path: "/secretseminar202601/thankyoumira",
    element: <ThankYouMiraPage />,
  },
  {
    path: "/spcacademy2026",
    element: <SpcAcademy2026Page />,
  },
  {
    path: "/spcacademy/entry202601",
    element: <SpcAcademyEntry202601Page />,
  },
  {
    path: "/spcacademy/entry202601/curriculum",
    element: <CurriculumPage />,
  },
  {
    path: "/coremember",
    element: <CoreMemberPage />,
  },
  {
    path: "/actworkook202601",
    element: <ActWorkook202601Page />,
  },
  {
    path: "/Thanks/2026lms3day",
    element: <Thanks2026lms3dayPage />,
  },
  {
    path: "/Thanks/2026lmsspgh",
    element: <Thanks2026lmsspghPage />,
  },
  {
    path: "/Thanks/2026lms3dayh",
    element: <Thanks2026lms3dayhPage />,
  },
  {
    path: "/Thanks/2026lms3daym",
    element: <Thanks2026lms3daymPage />,
  },
  {
    path: "/Thanks/2026lms3daymp1",
    element: <Thanks2026lms3daymp1Page />,
  },
  {
    path: "/Thanks/2026lms3dayme1",
    element: <Thanks2026lms3dayme1Page />,
  },
  {
    path: "/Thanks/2026lms3dayh1",
    element: <Thanks2026lms3dayh1Page />,
  },
  {
    path: "/Thanks/2026lms3dayhetopts",
    element: <Thanks2026lms3dayhetoptsPage />,
  },
  {
    path: "/Thanks/2026lms3dayhetoptsH",
    element: <Thanks2026lms3dayhetoptsHPage />,
  },
  {
    path: "/Thanks/2026lmssoudan",
    element: <Thanks2026lmssoudanPage />,
  },
  {
    path: "/Thanks/2026lmssoudan319",
    element: <Thanks2026lmssoudan319Page />,
  },
  {
    path: "/Thanks/2026lmssoudan322",
    element: <Thanks2026lmssoudan322Page />,
  },
  {
    path: "/Thanks/2026lmssoudan324",
    element: <Thanks2026lmssoudan324Page />,
  },
  {
    path: "/Thanks/2026lmssoudan327",
    element: <Thanks2026lmssoudan327Page />,
  },
  {
    path: "/keikoanaguchisecretLIVE20260323",
    element: <KeikoanaguchisecretLIVE20260323Page />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;